<template>
  <router-view />
</template>

<script>
export default {
  name: 'EmployeesWarningsIndex'
}
</script>
